// extracted by mini-css-extract-plugin
module.exports = {"dynamicHeader":"style_dynamicHeader__dS8Kc","scrolledFixed":"style_scrolledFixed___maeB","slideIn":"style_slideIn__9sap3","drawerOpenBody":"style_drawerOpenBody__xhbPV"};